import { type Ref, shallowRef, watch } from 'vue';

export function useDependentRef<T>(
  target: Ref<T>,
  initialValue: T,
  mapPercentCallback: (value: T) => T
) {
  const state = shallowRef(initialValue);

  watch(
    target,
    (value) => {
      state.value = mapPercentCallback ? mapPercentCallback(value) : value;
    },
    { immediate: true }
  );

  return state;
}
